export function chunkAndBase64Blob(blob, maxSizeKB) {
  return new Promise((resolve, reject) => {
    const maxChunkSize = maxSizeKB * 1024; // 转换为字节
    const totalSize = blob.size;
    let offset = 0;

    const base64Promises = [];

    while (offset < totalSize) {
      var promise = loadAndEncodeChunk(blob, offset, maxChunkSize);
      base64Promises.push(promise);

      offset += maxChunkSize;
    }

    Promise.all(base64Promises)
      .then((results) => {
        resolve(results);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function dataURItoBlob(base64Data) {
  let arr = base64Data.split(','),
    fileType = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    l = bstr.length,
    u8Arr = new Uint8Array(l);

  while (l--) {
    u8Arr[l] = bstr.charCodeAt(l);
  }
  return new Blob([u8Arr], {
    type: fileType,
  });
}

function loadAndEncodeChunk(data, offset, maxChunkSize) {
  return new Promise((resolve, reject) => {
    const chunk = data.slice(offset, offset + maxChunkSize);

    const chunkReader = new FileReader();
    chunkReader.onload = function (e) {
      var chunkData = e.target.result;
      var base64Data = chunkData.substring(chunkData.indexOf(',') + 1); // 去除 Data URL 的前缀部分

      resolve(base64Data);
    };

    chunkReader.onerror = function () {
      reject(new Error('分片读取错误.'));
    };

    chunkReader.readAsDataURL(chunk);
  });
}
